import { __decorate, __metadata, __param } from "tslib";
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import GroupShareEntity from '../entity/group-share-entity';
import QFYFShareEntity from '../entity/qfyf-share-entity';
import QQShareEntity from '../entity/qq-share-entity';
import ShareEntity from '../entity/share-entity';
import WeChatShareEntity from '../entity/wechat-share-entity';
import { IUserInfoDomainService } from '../../user-info/service/user-info-domain-service.interface';
var ShareAggregate = /** @class */ (function () {
    function ShareAggregate(docMetaDomainService, networkRequestService, userInfoDomainService) {
        this.docMetaDomainService = docMetaDomainService;
        this.networkRequestService = networkRequestService;
        this.userInfoDomainService = userInfoDomainService;
        this.shareEntity = new ShareEntity(docMetaDomainService, networkRequestService);
        this.groupShareEntity = new GroupShareEntity(docMetaDomainService, networkRequestService);
        this.qqShareEntity = new QQShareEntity(docMetaDomainService, networkRequestService, userInfoDomainService);
        this.weChatShareEntity = new WeChatShareEntity(docMetaDomainService, networkRequestService);
        this.qfyfShareEntity = new QFYFShareEntity(docMetaDomainService, networkRequestService);
    }
    ShareAggregate = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, INetworkRequestService),
        __param(2, IUserInfoDomainService),
        __metadata("design:paramtypes", [Object, Object, Object])
    ], ShareAggregate);
    return ShareAggregate;
}());
export default ShareAggregate;
